export default __webpack_public_path__ + "static/media/mutlusan.2f599304.jpg";